import { Component } from '@angular/core';

@Component({
	selector: 'pms-no-access',
	templateUrl: './no-access.component.html',
	styles: [],
	standalone: false,
})
export class NoAccessComponent {

	constructor() { }

}
